var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Signup-Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Signup-Flow-|-Enter-league-code-|-Error-Message-(Desktop)-",
    transform: "translate(-908.000000, -420.000000)",
    fill: "#EA4335",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(908.000000, 419.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape-2",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0 C3.15,0 0,3.15 0,7 C0,10.85 3.15,14 7,14 C10.85,14 14,10.85 14,7 C14,3.15 10.85,0 7,0 Z M10.0625,8.8375 L8.8375,10.0625 L7,8.225 L5.1625,10.0625 L3.9375,8.8375 L5.775,7 L3.9375,5.1625 L5.1625,3.9375 L7,5.775 L8.8375,3.9375 L10.0625,5.1625 L8.225,7 L10.0625,8.8375 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCross);
export default __webpack_public_path__ + "static/media/errorCross.fbd01b42b1627f04103a8e6f4b2cb556.svg";
export { ForwardRef as ReactComponent };